import RedirectService from "./redirect-service";

export default RedirectService;